import { isFocusable, tabbable } from 'tabbable';

const isTestEnvironment = import.meta.env.MODE === 'test';
const focusableOptions = {
  getShadowRoot: true,
  // jsdom has no layout, so full display checks treat every element as hidden.
  displayCheck: isTestEnvironment ? 'none' : 'full',
} as const;

type EventWithTargets = {
  target: EventTarget | null;
  currentTarget: EventTarget | null;
};

export function getFirstTabbableElement(element: HTMLElement) {
  return tabbable(element, focusableOptions)[0];
}

export function isEventFromFocusableDescendant(event: EventWithTargets) {
  if (!(event.target instanceof HTMLElement)) {
    return false;
  }

  const boundary = event.currentTarget instanceof HTMLElement ? event.currentTarget : null;

  for (let element: HTMLElement | null = event.target; element && element !== boundary; ) {
    if (isFocusable(element, focusableOptions)) {
      return true;
    }

    element = element.parentElement;
  }

  return false;
}
